import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadDesignComponent } from '../upload-design/upload-design.component';
import { UploadDesignService } from '@app/feature/store-admin/services/uploadDesign/uploadDesign.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { EditDesignComponent } from '../edit-design/edit-design.component';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ConfirmationDialogComponent } from '@app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';

@Component({
  selector: 'app-design-list',
  templateUrl: './design-list.component.html',
  styleUrls: ['./design-list.component.css']
})
export class DesignListComponent implements OnInit {

  designs: any [] = [];
  userId !: any;
  // For Infinite scroll of grid
  pageSize = 7; // No of items to load from server side i.e no of items to take
  initialItemsCount !: number;  // No of items to skip
  throttle = 1000;
  scrollDistance = 2;
  searchString !: string;
  // --------------------------

  searchDesignForm !: FormGroup;
  constructor(public dialog: MatDialog, private designService: UploadDesignService, private loaderService: LoaderService,
    private formBuilder: FormBuilder, private notificationService: NotificationService, private errorhandlerService: ErrorhandlerService) {
      this.searchDesignForm = this.formBuilder.group({
        // searchDesign: ['']
        searchDesign: ['']
      });
    }

  ngOnInit() {
    this.designs = [];
    this.userId = localStorage.getItem('userId') !== null ? localStorage.getItem('userId') : '';
    this.initialItemsCount = 0;
    this.fn_getUploadedDesigns();
  }

  /** Opens upload design dialog*/
  openDialog(): void {
    const dialogRef = this.dialog.open(UploadDesignComponent, {
      // width: '250px'
      // data: {name: this.name, animal: this.animal}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== 'false') {
        this.designs = [];
        this.initialItemsCount = 0;
        this.fn_getUploadedDesigns();
        }
    });
  }

  /** Opens edit design dialog */
  openDesignEditDialog(uploadDesignId: number): void {
    const dialogRef = this.dialog.open(EditDesignComponent, {
      // width: '250px'
       data: {uploadDesignId}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== 'false') {
        this.designs = [];
        this.initialItemsCount = 0;
        this.fn_getUploadedDesigns();
        }
    });
  }

  /** Opens delete design  confirm dialog */
  openConfirmationDialog(uploadDesignId: number): void  {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data:{         
        message : "Are you sure you want to delete this record ?",
        title: "Delete"
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === false)      {
              } else if (result == true) {
                this.loaderService.show();
                this.designService.deleteDesign(result.uploadDesignId, this.userId).subscribe((res: any) => {
                  if (res.StatusCode === 200) {
                    this.designs = [];
                    this.initialItemsCount = 0;
                    this.fn_getUploadedDesigns();
                    this.notificationService.success(res.Message, 'Design');
                  } else if (res.StatusCode === 500) {
                    this.notificationService.error('An error occured', 'Error');
                  }
                  this.loaderService.hide();
                   }, (err: any) => {
                    // this.notificationService.error('An error occured', 'Error');
                    this.loaderService.hide();
                    this.errorhandlerService.handleError(err);
                });
    }
    });
  }
   /** Function to add new lazy loaded items to original items list */
   fn_AddLazyLoadedItems (items: any) {
    if (items !== null) {
      if (items.length !== 0 && items !== null) {
        for (let i = 0; i < items.length; i++) {
          this.initialItemsCount = this.designs.push(items[i]);
        }
      }
    }
  }

  // Function called when clicked on search button
   fn_searchDesign(form: FormGroup) {
    // const debouncetime = pipe(debounceTime(5000));
      this.designs = [];
      this.initialItemsCount = 0;
      this.searchString = form.controls['searchDesign'].value;
      this.fn_getUploadedDesigns();
  }

  /**Function called on grid scroll to lazy load new content in grid */
  fn_getUploadedDesigns() {
    this.loaderService.show();
    this.designService.getUploadedDesigns(this.fn_CheckForNullUndefinedEmptyString(this.searchString), this.initialItemsCount,
    this.pageSize)
      .subscribe( (res: any) => {
        if (res.StatusCode === 200) {
            this.fn_AddLazyLoadedItems(res.Data.ResponseData);
            this.loaderService.hide();
         } else if (res.StatusCode === 500) {
            this.notificationService.error('Internal Server Error', 'Try Again');
            this.loaderService.hide();
         } else if (res.StatusCode === 204) {
           if (this.initialItemsCount <= 0)           {
            this.notificationService.error(res.Message, 'Record(s)');
           }
           this.loaderService.hide();
       } else {
        this.loaderService.hide();
       }
      }, err => {
        this.loaderService.hide();
        // this.notificationService.error('Internal Server Error', 'Try Again');
        this.errorhandlerService.handleError(err);
      });
  }

  fn_CheckForNullUndefinedEmptyString(value: any) {
    if (value === null || value === '' || value === undefined) {
      return '';
    } else {
      return value;
    }
  }
}
